import { render, staticRenderFns } from "./ChatAsk.vue?vue&type=template&id=34588c71&scoped=true&"
import script from "./ChatAsk.vue?vue&type=script&lang=js&"
export * from "./ChatAsk.vue?vue&type=script&lang=js&"
import style0 from "./ChatAsk.vue?vue&type=style&index=0&id=34588c71&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34588c71",
  null
  
)

export default component.exports